import store from "App/store/store";
import { selectUser } from "Features/user";

export function getReqHeader() {
	const token = selectUser.token(store.getState());
	const headers = { "content-type": "application/json" };
	if (token) {
		headers["x-jwt"] = token;
	}
	return { headers };
}
export function getReqHeaderFormData() {
	const token = selectUser.token(store.getState());
	const headers = { "Content-Type": "multipart/form-data" };
	if (token) {
		headers["x-jwt"] = token;
	}
	return { headers };
}
